import { render } from "./PreviewDemoPage.vue?vue&type=template&id=78af4a01&scoped=true"
import script from "./PreviewDemoPage.vue?vue&type=script&lang=js"
export * from "./PreviewDemoPage.vue?vue&type=script&lang=js"

import "./PreviewDemoPage.vue?vue&type=style&index=0&id=78af4a01&lang=less&scoped=true"

import exportComponent from "/builds/sqMDsSTzB/0/dsp/plazkart-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78af4a01"]])

export default __exports__